import { useQuery, QueryResult } from '@apollo/client'
import {
  Country,
  IsCultivatingTalentsEnabledForCompanyAndCountryQuery,
  IsCultivatingTalentsEnabledForCompanyAndCountryQueryVariables,
  IsRankingEnabledForCompanyAndCountryQuery,
  IsRankingEnabledForCompanyAndCountryQueryVariables,
} from '../../types'
import { IS_CULTIVATING_TALENTS_ENABLED, IS_RANKING_ENABLED } from './Queries'

export const useRankingIsEnabled = (
  companyId: string,
  country: Country,
): QueryResult<IsRankingEnabledForCompanyAndCountryQuery, IsRankingEnabledForCompanyAndCountryQueryVariables> => {
  return useQuery<IsRankingEnabledForCompanyAndCountryQuery, IsRankingEnabledForCompanyAndCountryQueryVariables>(IS_RANKING_ENABLED, {
    variables: { companyId, country },
    fetchPolicy: 'network-only',
  })
}

export const useCultivatingTalentsIsEnabled = (
  companyId: string,
  country: Country,
): QueryResult<IsCultivatingTalentsEnabledForCompanyAndCountryQuery, IsCultivatingTalentsEnabledForCompanyAndCountryQueryVariables> => {
  return useQuery<IsCultivatingTalentsEnabledForCompanyAndCountryQuery, IsCultivatingTalentsEnabledForCompanyAndCountryQueryVariables>(
    IS_CULTIVATING_TALENTS_ENABLED,
    {
      variables: { companyId, country },
      fetchPolicy: 'network-only',
    },
  )
}
